import {useTranslation} from 'react-i18next';

import {Grid, SxProps, Typography} from '@mui/material';

import {bodyPdf} from './styles';
import {PdfPageBreakWrapper} from './WrapperComponents/PdfPageBreakWrapper';
import {ComparisonCard} from '../../../components/ComparisonCard/ComparisonCard';
import {greenColors, orangeColors} from '../../../layouts/theme/designSystem';
import {ComparisonCardQuestion} from '../../../types/shared-types';

interface Props {
  removeLegend?: boolean;
  questions: ComparisonCardQuestion[];
  bubbleSize?: number;
  hideOverlap?: boolean;
}

export const QuestionCards = ({questions, removeLegend, bubbleSize, hideOverlap}: Props) => {
  const {t} = useTranslation('pdfDomain');

  const fontStyles: SxProps = {
    fontSize: '15px',
  };

  const overlapStyles: SxProps = {
    fontSize: '18px',
    marginBottom: '8px',
  };

  const paperStyles: SxProps = {
    padding: 2,
  };

  const legendIconStyles: SxProps = {
    width: '8px',
    height: '20px',
    borderRadius: 2,
  };

  return (
    <>
      {questions.map((question, index) => (
        <PdfPageBreakWrapper key={index} item xs={12}>
          <ComparisonCard
            methodItem={question.methodItem}
            firstIndicatorValue={question.results.valueManagement || question.results.valueDreamEmployer || 0}
            secondIndicatorValue={question.results.valueEmployees}
            overlap={hideOverlap ? undefined : question.results.overlap}
            indicatorSize={'40px'}
            paperBackgroundColor={orangeColors[3]}
            titleStyles={fontStyles}
            questionStyles={fontStyles}
            overridePaperStyles={paperStyles}
            questionsMargin={'20px'}
            overlapStyles={overlapStyles}
            cardMarginBottom={'8px'}
            bubbleSize={bubbleSize}
          />
        </PdfPageBreakWrapper>
      ))}
      {!removeLegend && (
        <Grid item container mt={1}>
          <Grid item mb={1} container flexWrap={'nowrap'}>
            <Grid item sx={legendIconStyles} bgcolor={greenColors[100]} />
            <Typography sx={bodyPdf} ml={1}>
              {t('shared.employees')}
            </Typography>
          </Grid>
          <Grid item container flexWrap={'nowrap'}>
            <Grid item sx={legendIconStyles} bgcolor={orangeColors[100]} />
            <Typography sx={bodyPdf} ml={1}>
              {t('shared.management')}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};
